import React, {useState} from 'react';
import {IonContent, IonPage, IonRouterOutlet} from '@ionic/react';
import {Route, RouteComponentProps, useLocation} from 'react-router-dom';
import {Keyboard, KeyboardResize} from '@capacitor/keyboard';
import {Capacitor} from '@capacitor/core';
import UIBackButton from '../components/UICommon/UIBackButton';
import UIHeading from '../components/UICommon/UIHeading';
import ChooseColorPage from './ChooseColorPage';
import ColorDeclarationPage from './ColorDeclarationPage';
import CreateColorDeclarationPage from './CreateColorDeclarationPage';

const ColorDeclarationRouting: React.FC<RouteComponentProps> = ({match}) => {
  const location = useLocation();
  const [isKeyboard, setKeyboard] = useState(0);
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  if (Capacitor.isNativePlatform()) {
    Keyboard.setResizeMode({
      mode: KeyboardResize.None,
    });
    Keyboard.addListener('keyboardWillShow', (info) => {
      document?.activeElement?.scrollIntoView(true);
      setKeyboard(info.keyboardHeight);
      setIsKeyboardOpen(true);
    });

    Keyboard.addListener('keyboardWillHide', () => {
      setKeyboard(0);
      setIsKeyboardOpen(false);
    });
  }

  return (
    <IonPage className='bg-white'>
      <IonContent scrollY={isKeyboardOpen}>
        <UIBackButton title='Färgdeklaration' href='/home'
          style={`px-5 pt-4 md:pt-0 md:absolute md:top-5 ${location.pathname === '/fargdeklaration' && 'md:hidden'}`}/>
        <div className={`${location.pathname === '/fargdeklaration/choose-color' && 'md:hidden '} md:pt-6`}>
          <UIHeading
            style="px-6 hidden md:flex"
            title="Färgdeklaration"
            date={true}
            big={true}
            description='Här kan du skapa nya, redigera och se dina tidigare färgdeklarationer'/>
        </div>
        <div className={
          `relative ${isKeyboardOpen ? 'overflow-y-scroll ' : ' '} ` +
          `${location.pathname === '/fargdeklaration/choose-color' ? ' h-full' : 'h-[90%] md:h-[85%]'}`}>
          <IonRouterOutlet>
            <Route exact={true} path={`/fargdeklaration`}>
              <ColorDeclarationPage />
            </Route>
            <Route path={`/fargdeklaration/new`}>
              <CreateColorDeclarationPage />
            </Route>
            <Route path={`/fargdeklaration/:id/new`}>
              <CreateColorDeclarationPage />
            </Route>
            <Route path={`/fargdeklaration/choose-color`}>
              <ChooseColorPage />
            </Route>
          </IonRouterOutlet>
        </div>
        {isKeyboardOpen && <div style={{height: isKeyboard - 100}}></div>}
      </IonContent>
    </IonPage>
  );
};

export default ColorDeclarationRouting;
